// extracted by mini-css-extract-plugin
module.exports = {"label-margin":"_148fOFlFX4-lMha9GcuHwm","description-margin":"kZ_U5Zp3QnLzQAa6mM4_-","checkbox-col":"kQRFHIyfsJ95ZhaYEDYOr"};